import React from "react";

import styles from "./MainPage.module.css";
import SlideBanner from "./components/SlideBanner";
import SupportDiv from "./components/SupportDiv";
import ProductBanner from "./components/ProductBanner";
import IntroduceBanner from "./components/IntroduceBanner";
import MapDiv from "./components/MapDiv";

export default function MainPage() {
  return (
    <div className={styles.MainPage}>
      <SlideBanner />
      <SupportDiv />
      <ProductBanner />
      <IntroduceBanner />
      <MapDiv />
    </div>
  );
}
